import { createTheme } from "@mui/material";

export const theme = createTheme({
  typography: {
    fontFamily: "var(--INTER)",
  },
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid #CFD9E8",
          margin: "0px 20px",
          alignContent: "center",
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        select: {
          padding: "0",
        },
        input: {
          fontSize: "16px", // Изменяем размер шрифта
          "&:active": {
            color: "#030C23",
          },
        },
      },
    },

    MuiDialog: {
      styleOverrides: {
        paper: {
          // maxWidth: '1000px', // Фиксированная ширина
          // width: '100%',      // Занимает всю доступную ширину (до maxWidth)
          borderRadius: "24px", // Устанавливаем желаемый радиус границы
        },
      },
    },

    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          width: "100% !important", // Устанавливаем желаемый радиус границы
        },
      },
    },

    MuiModal: {
      styleOverrides: {
        paper: {
          borderRadius: "24px", // Устанавливаем желаемый радиус границы
        },
      },
    },

    MuiListItemText: {
      styleOverrides: {
        root: {
          alignContent: "center",
          "& .MuiTypography-root": {
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "16px !important",
            lineHeight: "20px !important", // Изменяем размер шрифта внутреннего MuiTypography
          },
        },
      },
    },

    MuiListSubheader: {
      styleOverrides: {
        root: {
          margin: "0px 12px",
          padding: "12px 0px",
        },
      },
    },

    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          margin: "0px",
        },
      },
    },

    MuiAutocomplete: {
      styleOverrides: {
        input: {
          padding: "0 !important",
        },
        root: {
          "& .MuiOutlinedInput-root": {
            padding: "14px 16px !important",
          },
        },
      },
    },

    MuiTreeItem2: {
      styleOverrides: {
        // Указываем стили для классов компонента
        groupTransition: {
          padding: 0, // Убираем padding для группы дочерних элементов
          // Если вам нужно изменить этот конкретный класс, добавьте селектор
          "&.MuiCollapse-root": {
            padding: 0, // Убираем padding для класса MuiCollapse-root
          },
        },

        content: {
          "&:hover": {
            backgroundColor: "#fff",
          },
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: "0",
          lineHeight: "16px",
          "&:focus": {
            color: "#030C23",
            "& .MuiSelect-select": {
              alignContent: "center",
              color: "#030C23", // Изменяем размер шрифта внутреннего MuiTypography
            },
          },
          "&::placeholder": {
            color: "#a1a8b0", // Цвет placeholder
            opacity: 1, // Обязательно для полной видимости
          },
        },
        root: {
          padding: "14px 16px",
          backgroundColor: "rgba(16, 16, 16, 0.03)",
          color: "#030C23",
          fontSize: "16px",
          borderRadius: "8px",
          "&:active": {
            color: "#030C23",
            "& .MuiSelect-select": {
              color: "#030C23", // Изменяем размер шрифта внутреннего MuiTypography
            },
          },
          "& .MuiSelect-select::placeholder": {
            color: "#a1a8b0", // Цвет placeholder
            opacity: 1, // Обязательно для полной видимости
          },
          "& .MuiSelect-select": {
            alignContent: "center", // Изменяем размер шрифта внутреннего MuiTypography
          },
          "&:hover": {
            color: "#030C23",
            outline: "none",
          },
        },
      },
    },

    MuiTabs: {
      styleOverrides: {
        flexContainer: {
          gap: "8px",
        },
      },
    },

    MuiFormLabel: {
      styleOverrides: {
        input: {
          color: "#030C23",
          padding: "14.5px 24px",
        },
        root: {
          fontSize: "14px",
        },
      },
    },

    MuiAccordion: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: "16px ",
        },
      },
    },

    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          flexDirection: "row !important",
          color: "#030C23",
          boxShadow: "none",
          height: "32px",
        },
        content: {
          margin: 0,
        },
        "&.Mui-expanded": {
          backgroundColor: "darkgrey", // Цвет фона при раскрытии
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        thumb: {
          borderRadius: "50%",
          backgroundColor: "#fff",
          border: "1px solid var(--accent)",
          width: 20,
          height: 20,
        },
        rail: {
          backgroundColor: "#CFD9E8",
          opacity: 1, // Цвет левой части
        },
        track: {
          backgroundColor: "#1876D2",
          opacity: 1, // Цвет правой части
        },
      },
    },
    "& .MuiSlider-thumb": {
      height: 24,
      width: 24,
      backgroundColor: "#fff",
      border: "2px solid currentColor",
      "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
        boxShadow: "inherit",
      },
      "&::before": {
        display: "none",
      },
    },
    "& .MuiSlider-valueLabel": {
      lineHeight: 1.2,
      fontSize: 12,
      background: "unset",
      padding: 0,
      width: 32,
      height: 32,
      borderRadius: "50% 50% 50% 0",
      backgroundColor: "#52af77",
      transformOrigin: "bottom left",
      transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
      "&::before": { display: "none" },
      "&.MuiSlider-valueLabelOpen": {
        transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
      },
      "& > *": {
        transform: "rotate(45deg)",
      },
    },
  },
});

export const TooltipProps = {
  tooltip: {
    sx: {
      padding: "6px 12px",
      color: "var(--white)",
      backgroundColor: "#414447",
      borderRadius: "8px",
      maxWidth: 300,
      fontSize: "14px",
    },
  },
};
